// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import Images from '../../basics/Images';

const PoiMarkerIcon = (props) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <div
    // Note:
    // 'onMarkerClick' name is used to match what MMap needs, so don't anyhow change this props name.
    onClick={props.onMarkerClick}
  >
    <img
      src={Images.Local.MarkerPoi}
      alt={Images.Local.MarkerPoi}
      width={props.width}
      height={props.height}
      // Transform is required to display the bottom tip of the marker icon
      // at the lat lng position
      style={{ transform: 'translate(-50%, -100%)' }}
    />
  </div>
);

PoiMarkerIcon.propTypes = {
  width:         PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  height:        PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  onMarkerClick: PropTypes.func,
};

PoiMarkerIcon.defaultProps = {
  width:         40,
  height:        40,
  onMarkerClick: () => {},
};

export default PoiMarkerIcon;
